import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/social-media-poshmark-sales';

export default function Example() {
  return (
    <>
      <Head>
        <title>Tips To Boost Poshmark Sales With An Effective Instagram</title>
        <meta
          name='description'
          content='Being in social commerce is not just being there. So many sellers are already on social media, and as such, you must rise above the rest. There are 6 c’s of social commerce that you must keep in mind:'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/social-media-poshmark-sales' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/social-media-poshmark-sales' />
        <meta property='og:title' content='Tips To Boost Poshmark Sales With An Effective Instagram' />
        <meta
          property='og:description'
          content='Being in social commerce is not just being there. So many sellers are already on social media, and as such, you must rise above the rest. There are 6 c’s of social commerce that you must keep in mind:'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=4' />
        <meta property='article:published_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:modified_time' content='2022-01-22T00:00:00.000Z' />
        <meta property='article:tag' content='Poshmark' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
